module.exports = __webpack_public_path__ + "img/handyman-bg.4a5c6569.jpg";